import { Lock } from 'lucide-react';

export function AccessDeniedCard({ message }) {
  return (
    <div className="admin-card">
      <div className="admin-card-body flex flex-col items-center justify-center py-12">
        <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-4">
          <Lock className="h-6 w-6 text-red-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Access Denied</h3>
        <p className="text-gray-500 text-center max-w-sm">{message}</p>
      </div>
    </div>
  );
}
